/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：359
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.NAMED_TAG = "named"
exports.NAME_TAG = "name"
exports.UNMANAGED_TAG = "unmanaged"
exports.OPTIONAL_TAG = "optional"
exports.INJECT_TAG = "inject"
exports.MULTI_INJECT_TAG = "multi_inject"
exports.TAGGED = "inversify:tagged"
exports.TAGGED_PROP = "inversify:tagged_props"
exports.PARAM_TYPES = "inversify:paramtypes"
exports.DESIGN_PARAM_TYPES = "design:paramtypes"
exports.POST_CONSTRUCT = "post_construct"
